export interface ValuationRange {
  min: number
  max: number
}

export interface Valuation {
  range: ValuationRange
  prevRange?: ValuationRange
  value: number
}

export interface ValuationResponse {
  date: string
  value: number
  meta: {
    model: string
    standarderror: number
    score: number
    range: {
      min: number
      max: number
    }
    value: number
  }
  calc: {
    address: {
      nation: string
      street: string
      house_number: string
      zip: string
      town: string
    }
    coordinates: {
      lat: number
      lng: number
    }
  }
}

export enum SprengnetterCategory {
  COMMERCIAL = 'COMMERCIAL',
  SINGLE_FAMILY_HOUSE = 'EFH',
  APARTMENT = 'ETW',
  LAND = 'GRD',
}
